import { render, staticRenderFns } from "./Insurers.vue?vue&type=template&id=2f3b2e7e"
import script from "./Insurers.vue?vue&type=script&lang=js"
export * from "./Insurers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports